import { colors } from "@wrstudios/theme";
export default [
/**
 * LINE (radius behaves like a line and so does polygon until you add a second vertice)
 */
{
  id: "gl-draw-line-active",
  type: "line",
  filter: ["all", ["==", "active", "true"], ["==", "$type", "LineString"], ["!=", "mode", "static"]],
  layout: {
    "line-cap": "round",
    "line-join": "round"
  },
  paint: {
    "line-color": colors.blue[300],
    "line-dasharray": [0.2, 2],
    "line-width": 2
  }
}, {
  id: "gl-draw-line-inactive",
  type: "line",
  filter: ["all", ["==", "active", "false"], ["==", "$type", "LineString"], ["!=", "mode", "static"]],
  layout: {
    "line-cap": "round",
    "line-join": "round"
  },
  paint: {
    "line-color": colors.blue[300],
    "line-width": 0
  }
},
/**
 * POLYGONS
 */
{
  id: "gl-draw-polygon-fill",
  type: "fill",
  filter: ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
  paint: {
    "fill-color": colors.blue[300],
    "fill-outline-color": colors.blue[300],
    "fill-opacity": 0.1
  }
}, // polygon outline stroke
// This doesn't style the first edge of the polygon, which uses the line stroke styling instead
{
  id: "gl-draw-polygon-stroke-active",
  type: "line",
  filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
  layout: {
    "line-cap": "round",
    "line-join": "round"
  },
  paint: {
    "line-color": colors.blue[300],
    "line-dasharray": [0.2, 2],
    "line-width": 2
  }
}, {
  id: "gl-draw-polygon-stroke-inactive",
  type: "line",
  filter: ["all", ["==", "active", "false"], ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
  layout: {
    "line-cap": "round",
    "line-join": "round"
  },
  paint: {
    "line-color": colors.blue[300],
    "line-width": 2
  }
}, // vertex point halos
{
  id: "gl-draw-polygon-and-line-vertex-halo",
  type: "circle",
  filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
  paint: {
    "circle-radius": 5,
    "circle-color": "#FFF"
  }
}, // vertex points
{
  id: "gl-draw-polygon-and-line-vertex",
  type: "circle",
  filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
  paint: {
    "circle-radius": 3,
    "circle-color": colors.blue[500]
  }
},
/**
 * RADIUS
 */
{
  id: "gl-draw-radius",
  type: "line",
  filter: ["all", ["==", "active", "true"], ["==", "meta", "radius"], ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
  layout: {
    "line-cap": "round",
    "line-join": "round"
  },
  paint: {
    "line-color": colors.blue[300],
    "line-dasharray": [0.2, 2],
    "line-width": 2
  }
}];